<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Device Status</th>
                    <th class="col-sm-3">Commercial Distribution End Date</th>
                    <th class="col-sm-5">Reason for Device Discontinuation</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Status')">
                      <label controlName="deviceStatus"> </label> </td>
                    <td [ngClass]="isDefault('Commercial Distribution End Date')">
                      <label controlName="commercialDistributionEndDate"> </label> </td>
                    <td [ngClass]="isDefault('Reason for Device Discontinuation')" class="breakAll">
                      <label controlName="reasonForDeviceDiscontinuation"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-right-padding no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-7">Customer Service Center Name</th>
                    <th class="col-sm-5">Customer Service Center Phone Number</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Customer Service Center Name')">
                      <label controlName="customerServiceCenterName"> </label> </td>
                    <td [ngClass]="isDefault('Customer Service Center Phone Number')">
                      <label controlName="customerServiceCenterPhone"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Eligible for Health Care Benefit or Reimbursement?</th>
                    <th class="col-sm-3">Health Care Benefit Code(s)</th>
                    <th class="col-sm-5">Reason for Not Providing Health Care Benefit Code</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Eligible for Health Care Benefit or Reimbursement?')"><label
                        controlName="eligibleForHealthCareBenefitsOrReimbursement"></label></td>

                    <td>
                      <table formArrayName="healthBenefitCodesForm">
                        <tbody>
                          <ng-container *ngIf="healthBenefitCodesForm?.controls?.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of healthBenefitCodesForm.controls; let i = index">
                              <td [ngClass]="isDefault('Health Care Benefit Code(s)')"><label controlName="value"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>

                    <td [ngClass]="isDefault('Reason for Not Providing Health Care Benefit Code')" class="breakAll"><label
                        controlName="reasonForNotProvidingHealthCareBenefitCode"></label></td>

                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Commercial Distribution End Date</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Commercial Distribution End Date')">
                      <label controlName="commercialDistributionEndDate"> </label>
                      </td>
                      </tr>
                      </tbody>
                      </table>
                      </td>
                      <td class="col-sm-6 no-left-padding no-right-padding"
                        [ngClass]="isDefault('Medical Insurance Code(s)')">
                        <table formArrayName="medicalInsuranceCodesForm"
                          class="table table-inner table-condensed table-striped">
                          <tbody>
                            <tr>
                              <th>Medical Insurance Code(s)</th>
                            </tr>
                            <ng-container *ngIf="medicalInsuranceCodesForm.controls.length; else emptyTemplate1field">
                              <tr formGroupName="{{i}}"
                                *ngFor="let name of medicalInsuranceCodesForm.controls; let i = index">
                                <td colspan="2" [ngClass]="isDefault('Medical Insurance Code(s)')">
                                  <label controlName="medicalInsuranceCode"></label>
                                </td>
                              </tr>
                      </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>
